// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3VydA","actions":"GroupTable_actions__1aPei","deleteModalFooter":"GroupTable_deleteModalFooter__1UOAr"};